module.exports = __webpack_public_path__ + "static/media/back-blue.7e65169f.png";